export const locale = {
  lang: 'de',
  data: {
    MENU: {
      DASHBOARD: {
        COLLAPSIBLE: 'Dashboards',
        BADGE: '2',
        ANALYTICS: 'Analytik',
        ECOMMERCE: 'E-Commerce'
      },
      APPS: {
        SECTION: 'Apps & Seiten',
        EMAIL: 'Email',
        CHAT: 'Plaudern',
        TODO: 'Machen',
        CALENDAR: 'Kalender',
        INVOICE: {
          COLLAPSIBLE: 'Rechnung',
          LIST: 'Liste',
          PREVIEW: 'Vorschau',
          EDIT: 'Bearbeiten',
          ADD: 'Hinzufügen'
        },
        ECOMMERCE: {
          COLLAPSIBLE: 'E-Commerce',
          SHOP: 'Geschäft',
          DETAIL: 'Einzelheiten',
          WISHLIST: 'Wunschzettel',
          CHECKOUT: 'Überprüfen',
          DELIVERYFEE: 'Taxa de entrega'
        },
        USER: {
          COLLAPSIBLE: 'Nutzer',
          LIST: 'Liste',
          VIEW: 'Aussicht',
          EDIT: 'Bearbeiten'
        }
      },
      PAGES: {
        SECTION: 'Seiten',
        AUTH: {
          COLLAPSIBLE: 'Authentifizierung',
          LOGIN1: 'Login V1',
          LOGIN2: 'Login V2',
          REGISTER1: 'Register V1',
          REGISTER2: 'Register V2',
          FORGOTPASSWORD1: 'Passwort vergessen V1',
          FORGOTPASSWORD2: 'Passwort vergessen V2',
          RESETPASSWORD1: 'Passwort zurücksetzen V1',
          RESETPASSWORD2: 'Passwort zurücksetzen V2'
        },
        ACCOUNTSETTINGS: 'Kontoeinstellungen',
        PROFILE: 'Profil',
        FAQ: 'FAQ',
        KB: 'Wissensbasis',
        PRICING: 'Preisgestaltung',
        BLOG: {
          COLLAPSIBLE: 'Blog',
          LIST: 'Liste',
          DETAILS: 'Einzelheiten',
          EDIT: 'Bearbeiten'
        },
        MAIL: {
          COLLAPSIBLE: 'Mail-Vorlage',
          WELCOME: 'Herzlich willkommen',
          RESET: 'Passwort zurücksetzen',
          VERIFY: 'Überprüfen',
          DEACTIVATE: 'Deaktivieren',
          INVOICE: 'Rechnung',
          PROMOTIONAL: 'Werbung'
        },
        MISC: {
          COLLAPSIBLE: 'Verschiedenes',
          COMINGSOON: 'Kommt bald',
          NOTAUTH: 'Nicht genehmigt',
          MAINTENANCE: 'Instandhaltung',
          ERROR: 'Error'
        }
      },
      UI: {
        SECTION: 'Benutzeroberfläche',
        TYPOGRAPHY: 'Typografie',
        COLORS: 'Farben',
        FEATHER: 'Feder',
        CARDS: {
          COLLAPSIBLE: 'Karten',
          BADGE: 'Neu',
          BASIC: 'Basic',
          ADVANCE: 'Voraus',
          STATISTICS: 'Statistiken',
          ANALYTICS: 'Analytik',
          ACTIONS: 'Aktionen'
        },
        COMPONENTS: {
          COLLAPSIBLE: 'Komponenten',
          ALERTS: 'Warnungen',
          AVATAR: 'Benutzerbild',
          BADGES: 'Abzeichen',
          BREADCRUMBS: 'Semmelbrösel',
          BUTTONS: 'Tasten',
          CAROUSEL: 'Karussell',
          COLLAPSE: 'Zusammenbruch',
          DIVIDER: 'Teiler',
          DROPDOWNS: 'Dropdowns',
          GROUP: 'Listengruppe',
          OBJECTS: 'Medienobjekte',
          MODALS: 'Modale',
          COMPONENT: 'Navs',
          PAGINATION: 'Seitennummerierung',
          PBADGES: 'Pillenabzeichen',
          PILLS: 'Pillen',
          POPOVERS: 'Popovers',
          PROGRESS: 'Fortschritt',
          RATINGS: 'Bewertungen',
          SPINNER: 'Spinner',
          TABS: 'Tabs',
          TIMELINE: 'Zeitleiste',
          TOASTS: 'Toast',
          TOOLTIPS: 'Tooltips'
        },
        EX: {
          COLLAPSIBLE: 'Erweiterung',
          SWEET_ALERTS: 'Süße Warnungen',
          BLOCKUI: 'BlockUI',
          TOASTER: 'Toastr',
          SLIDER: 'Schieberegler',
          DRAGDROP: 'Ziehen und loslassen',
          TOUR: 'Tour',
          CLIPBOARD: 'Zwischenablage',
          MEDIAPLAYER: 'Media Player',
          CONTEXTMENU: 'Kontextmenü',
          SWIPER: 'Swiper',
          TREEVIEW: 'Baumsicht',
          I18N: 'I18n'
        },
        LAYOUTS: {
          COLLAPSIBLE: 'Seitenlayouts',
          COLLAPSED_MENU: 'Reduziertes Menü',
          BOXED_LAYOUT: 'Boxed Layout',
          WITHOUT_MENU: 'Ohne Menü',
          LAYOUT_EMPTY: 'Layout leer',
          LAYOUT_BLANK: 'Layout leer'
        }
      },
      FT: {
        SECTION: 'Formulare & Tabellen',
        ELEMENT: {
          COLLAPSIBLE: 'Formularelemente',
          INPUT: 'Eingang',
          INPUTGROUPS: 'Eingabegruppen',
          INPUTMASK: 'Eingabemaske',
          TEXTAREA: 'Textbereich',
          CHECKBOX: 'Kontrollkästchen',
          RADIO: 'Radio',
          SWITCH: 'Schalter',
          SELECT: 'Wählen',
          NUMBERINPUT: 'Zahleneingabe',
          FILEUPLOADER: 'Datei-Uploader',
          QUILLEDITOR: 'Federkiel-Editor',
          FLATPICKER: 'Flatpicker',
          DATETIMEPICKER: 'Datums- und Zeitauswahl'
        },
        LAYOUTS: 'Formularlayouts',
        WIZARD: 'Formzauberer',
        VALIDATION: 'Formularvalidierungen',
        REPEATER: 'Form Repeater',
        TABLE: 'Tabelle',
        DATATABLES: 'DataTables'
      },
      CM: {
        SECTION: 'Diagramme & Karten',
        CHARTS: {
          COLLAPSIBLE: 'Diagramme',
          BADGE: '2',
          APEX: 'Apex',
          CHARTJS: 'ChartJS'
        },
        MAPS: 'Google Maps'
      },
      OTHERS: {
        SECTION: 'Andere',
        LEVELS: {
          COLLAPSIBLE: 'Menüebenen',
          SECOND: 'Zweites Level',
          SECOND1: {
            COLLAPSIBLE: 'Zweites Level',
            THIRD: 'Drittes Level',
            THIRD1: 'Drittes Level'
          }
        },
        DISABLED: 'Deaktiviertes Menü',
        DOCUMENTATION: 'Dokumentation',
        SUPPORT: 'Unterstützung erhöhen'
      }
    }
  }
};
